export const hasSQLInjection = (input, maxLength = 50) => {
  if (input.length > maxLength) return true;

  const pattern =
    /('|--|;|\/\*|\*\/|xp_|exec|select|insert|update|delete|drop|union| or | and )/i;
  return pattern.test(input);
};
